import styled, {css} from 'styled-components'

const ImgWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    object-fit: cover;

    &:before {
      content: '';
      float: left;
      padding-top: 100%;
    }
  }

`

export default ImgWrapper



// WEBPACK FOOTER //
// ./src/components/ImgWrapper.js